import React, { useState, memo, useRef, useEffect } from 'react';
import {closeModal, Modal as ModalComponent} from '../Modal.jsx';
import {Portal} from '../Portal.jsx';
import Errors from '../Errors.jsx';
import Select from '../Select.jsx';
import { fetchJson } from '../../../helpers/fetch.js';

import {
  organization_datagrid_bulk_connect_users_path,
  organization_datagrid_connectable_users_path
} from '~/routes'

const MODAL_ID = 'manage-connected-users-modal';

export const ManageConnectedUsersModal = ({handleCloseModal, row_id, connectedUsers, setConnectedUsers, manage_organization_users = false}) => {
  const [loading, setLoading] = useState(true);
  const [connectableUserOptions, setConnectableUserOptions] = useState([]);
  const [connectedUserOptions, setConnectedUserOptions] = useState(connectedUsers.map(v => v.id));

  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState([]);
  const formRef = useRef();

  const handleClose = () => {
    closeModal(MODAL_ID);
    handleCloseModal();
  };

  const submit = (e) => {
    e.preventDefault();
    setSaving(true);

    jQuery.post(organization_datagrid_bulk_connect_users_path({datagrid_row_id: row_id}), jQuery(formRef.current).serialize())
      .done((_) => {
        setConnectedUsers(connectableUserOptions.filter(v => connectedUserOptions.includes(v.value)).map(v => ({id: v.value, name: v.name})));
        setErrors([]);
        handleClose();
      })
      .fail((res) => {
        let responseJSON = res.responseJSON ? res.responseJSON.errors : {server: [{message: I18n.t('unexpected_error')}]};
        setErrors(responseJSON);
      });

    setSaving(false);
  };

  useEffect(() => {
    if (loading) {
      fetchJson(organization_datagrid_connectable_users_path()).then(res => {
        setConnectableUserOptions(res.map(v => ({value: v.id, label: `${v.name} (${v.email_address})`, name: v.name})));
        setLoading(false);
      })
    }
  }, []);

  return (
    <Portal
      id={MODAL_ID}
      size='md'
      title={I18n.t('users')}
      onClose={handleClose}
      cancelLabel={I18n.t('close')}
      onSave={submit}
      saving={saving}
      hideSaveButton={!manage_organization_users}
      cssClassNameCancelButton={manage_organization_users ? 'pull-left' : 'pull-right'}
      component={ModalComponent}
    >
      <div>
        <Errors errors={errors}/>

        <form ref={formRef} onSubmit={submit}>
          <div className='form-group'>
            <label>{I18n.t('users_connected_with_organization')}</label>
            <Select
              name='connect_user_ids[]'
              options={connectableUserOptions}
              onChange={(val) => setConnectedUserOptions(val)}
              value={connectedUserOptions}
              disabled={!manage_organization_users}
              isMulti
            />
          </div>
        </form>
      </div>
    </Portal>
  );
};

export const valueGetter = (params) => {
  if(!params.data) return null;
  return params.data[params.colDef.field]?.map(v => v['name'])?.join(',') || ''
};

const ConnectedUsersLinkCellRenderer = memo((params) => {
  const {connected_users, row_id} = params.data || {};
  const {manage_organization_users} = params.context?.permissions;

  const [openModal, setOpenModal] = useState(false);
  const [connectedUsers, setConnectedUsers] = useState(connected_users||[]);

  const handleCloseModal = () => setOpenModal(false);
  const handleClick = () => setOpenModal(true);

  return (<>
    <a href='#' onClick={handleClick}>{connectedUsers.map(v => v.name).join(',') || '#'}</a>
    {openModal && <ManageConnectedUsersModal {...{handleCloseModal, row_id, connectedUsers, setConnectedUsers, manage_organization_users}}></ManageConnectedUsersModal>}
  </>);
});

export default ConnectedUsersLinkCellRenderer;